export default [
    {
      path: 'd-fin/gefin-mais',
      name: 'gefin-mais',
      component: () => import('./index'),
      children: [],
      meta: {
        visible: false,
        title: 'Financeiro',
        order: '5',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'D-FIN', link: 'd-fin' },
          { name: 'Mais' }
        ]
      }
    },
  ]